import { render, staticRenderFns } from "./SettingsWorkspacePlatformForm.vue?vue&type=template&id=9a1b4e9c"
import script from "./SettingsWorkspacePlatformForm.vue?vue&type=script&lang=js"
export * from "./SettingsWorkspacePlatformForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports